// Components
// Libs
import { giveawayPickerSteps } from '@/lib/giveawayPicker/steps';

import { Step } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/StepsWrapper/Step';

export function StepsWrapper() {
    return (
        <header className="mb-4 flex justify-center gap-6 lg:gap-12">
            {giveawayPickerSteps.map((step) => (
                <Step key={step.name} step={step} />
            ))}
        </header>
    );
}
